export default "__VITE_ASSET__a08ef528__"